import { API } from "@/lib/api";

// Streams an AI chat reply token-by-token via SSE from POST /api/ai/chat.
// Calls onChunk(text) for each incremental piece; resolves with the full reply.
export async function streamChat({ sessionId, message, onChunk }) {
  const res = await fetch(`${API}/ai/chat`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ session_id: sessionId, message }),
  });
  if (!res.ok) {
    let detail = "The AI assistant is unavailable right now.";
    try { detail = (await res.json()).detail || detail; } catch { /* keep default */ }
    throw new Error(detail);
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let full = "";

  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const events = buffer.split("\n\n");
    buffer = events.pop();
    for (const evt of events) {
      const line = evt.trim();
      if (!line.startsWith("data:")) continue;
      let data;
      try { data = JSON.parse(line.slice(5).trim()); } catch { continue; }
      if (data.error) throw new Error(data.error);
      if (data.chunk) {
        full += data.chunk;
        onChunk(full);
      }
    }
  }
  return full;
}
